(() => {
  if (window.__equibowlStudioBooted) return;
  window.__equibowlStudioBooted = true;
  const updates = new WeakMap();
  const setup = () => {
    document.querySelectorAll('.eq-studio-shop').forEach(shop => {
      if (updates.has(shop)) { updates.get(shop)(); return; }
      shop.dataset.studioReady = 'true';
      const tools = shop.querySelector('[data-studio-tools]');
      const diets = shop.querySelector('[data-studio-diets]');
      const search = shop.querySelector('[data-studio-search]');
      const cards = Array.from(shop.querySelectorAll('[data-studio-card]'));
      const empty = shop.querySelector('[data-studio-empty]');
      const teaser = shop.querySelector('[data-studio-teaser]');
      const groups = Array.from(shop.querySelectorAll('[data-studio-group]'));
      let category = 'all';
      let diet = 'all';
      tools.hidden = false;
      diets.hidden = false;
      const update = () => {
        const term = search.value.trim().toLocaleLowerCase();
        let count = 0;
        cards.forEach(card => {
          const visible = (category === 'all' || card.dataset.studioGroupCard === category || card.dataset.eqCategoryCard === category) && (diet === 'all' || card.dataset.studioCardDiet === diet) && (!term || card.dataset.studioName.toLocaleLowerCase().includes(term));
          card.hidden = !visible;
          if (visible) count++;
        });
        groups.forEach(group => { group.hidden = !cards.some(card => !card.hidden && card.dataset.studioGroupCard === group.dataset.studioGroup); });
        if (empty) empty.hidden = count !== 0;
        if (teaser) teaser.hidden = category !== 'all' || diet !== 'all' || Boolean(term);
        shop.querySelectorAll('[data-studio-category]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.studioCategory === category)));
        shop.querySelectorAll('[data-studio-diet]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.studioDiet === diet)));
      };
      shop.addEventListener('click', event => {
        const categoryButton = event.target.closest('[data-studio-category]');
        const dietButton = event.target.closest('[data-studio-diet]');
        if (categoryButton) { category = categoryButton.dataset.studioCategory; diet = 'all'; update(); }
        if (dietButton) { diet = dietButton.dataset.studioDiet; update(); }
      });
      shop.addEventListener('studio:preference', event => {
        if (!['egg','chicken','veg'].includes(event.detail)) return;
        category = 'bowls'; diet = event.detail; search.value = ''; update();
      });
      updates.set(shop, update);
      search.addEventListener('input', update);
      search.addEventListener('search', update);
      update();
    });
    document.querySelectorAll('[data-studio-hero-diets]').forEach(group => { group.hidden = false; });
    document.querySelectorAll('[data-studio-jump-diet]').forEach(button => {
      if (button.dataset.studioReady) return;
      button.dataset.studioReady = 'true';
      button.addEventListener('click', () => {
        const shop = document.querySelector('.eq-studio-shop');
        if (!shop) return;
        shop.dispatchEvent(new CustomEvent('studio:preference', {detail:button.dataset.studioJumpDiet}));
        shop.scrollIntoView({behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block:'start'});
        const active = shop.querySelector(`[data-studio-diet="${button.dataset.studioJumpDiet}"]`);
        if (active) active.focus({preventScroll:true});
      });
    });
  };
  setup();
  document.addEventListener('shopify:section:load', setup);
  window.addEventListener('pageshow', setup);
})();
